/* Presentation only: avoid a duplicate floating purchase CTA over the final CTA. */
(() => {
  if (window.__grCTAEnhancement || !('IntersectionObserver' in window)) return;
  window.__grCTAEnhancement = true;
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.intersectionRatio >= .15) visible.add(entry.target);
      else visible.delete(entry.target);
    }
    for (const card of visible) if (!card.isConnected) visible.delete(card);
    document.body.classList.toggle('gr-cta-in-view', visible.size > 0);
  }, { threshold: [0, .15] });
  const init = () => {
    observer.disconnect();
    visible.clear();
    document.body.classList.remove('gr-cta-in-view');
    document.querySelectorAll('.gr-cta').forEach(card => observer.observe(card));
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
